<div class="login-wave-header">
	<img src="assets/images/Logo-KeFirma 2.png" alt="KeFirma" class="wave-logo-icon" />
	<span class="wave-company-name mb-2">
		@if (companyLogo()) {
			<img [src]="companyLogo()" alt="Company Logo" />
		} @else {
			{{companyName()}}
		}
	</span>

	@if (showBackButton()) {
		<div class="back-nav-abs header-back-btn-pos pt-2 header-back-btn" (click)="goBack()">
			<i class="bi bi-arrow-left"></i>
			Torna indietro
		</div>
	}
</div>
